
// export default {
//   path: "/commonPhrases",
//   name: "commonPhrases",
//   meta: {
//     title: '用户常用语'
//   },
//   component: import("@/pages/commonPhrases/index.vue"),
// };
import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/commonPhrases",
  name: "commonPhrases",
  redirect: {
    name: "commonPhrases/index",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "/commonPhrases/index",
      name: "commonPhrases/index",
      meta: {
        ...meta,
        title: "用户常用语",
      },
      component: () => import("@/pages/commonPhrases/index.vue"),
    },
    {
      path: "/commonPhrases/edit",
      name: "commonPhrases/edit",
      meta: {
        ...meta,
        title: "常用语编辑",
      },
      component: () => import("@/pages/commonPhrases/PhrasesEdit.vue"),
    },
  ],
};
